export interface PropertyRevenueConfiguration {
  id: string
  seasonGroup?: {
    id: string
    name: string
  }
  yieldingGroup?: {
    id: string
    name: string
  }
  yieldingMap?: {
    id: string
    name: string
  }
  floorRate?: number
  nightlyMinimumFloor?: number
  name?: string
  regionId?: string
  regionName?: string
  floorRateByMonth?: number[]
  integratedPricing?: boolean
  pricingSourceType?: PricingSourceType
}

export interface PropertyRevenueConfigurationMutation {
  id: string
  yieldingMapId?: string
  yieldingGroupId?: string
  seasonGroupId?: string
  message?: string
  nightlyMinimumFloor?: number
  floorRateByMonth?: number[]
  pricingSource?: PricingSourceType
}

export enum PricingSourceType {
  voyage = 'VOYAGE',
  wheelhouse = 'WHEELHOUSE',
}

export enum PricingSourceProvider {
  voyage = 'voyage',
  wheelhouse = 'wheelhouse',
}

export enum PropertyRevenueConfigurationSections {
  otaPromotionsAndDiscounts = 'ota-promotions-and-discounts',
  ownerRestrictions = 'owner-restrictions',
  revenueConfiguration = 'config',
}
